import SpeechBubbleIcon from "../../../../assets/svg/icon-speechbubble.svg?react";

export const SpeechBubble = () => {
  return <SpeechBubbleIcon />;
};
